'use client';

import { useEffect, useState } from 'react';

import type { NavMegaMenu } from '../../types/navigation';

const getDefaultMegaGroupId = (megaMenu: NavMegaMenu) =>
  megaMenu.defaultGroupId ||
  megaMenu.categories.find((category) => category.sectionId)?.sectionId ||
  megaMenu.groups[0]?.id ||
  '';

const useHeaderMegaMenu = (megaMenu: NavMegaMenu) => {
  const [activeGroupId, setActiveGroupId] = useState(getDefaultMegaGroupId(megaMenu));

  useEffect(() => {
    setActiveGroupId(getDefaultMegaGroupId(megaMenu));
  }, [megaMenu]);

  const activeGroup =
    megaMenu.groups.find((group) => group.id === activeGroupId) || megaMenu.groups[0];

  return {
    activeGroup,
    activeGroupId,
    setActiveGroupId,
  };
};

export default useHeaderMegaMenu;
